import { Fragment } from "react";

import ErrorBoundary from "components/Ui/ErrorBoundary/ErrorBoundary";

/**
 * Renders one `<td>` per visible column by looking up `renderers[col.id]`.
 * Use inside a `<tr>` after defining a renderers map keyed by column id.
 *
 * Wrapped in an ErrorBoundary so a single failing cell degrades to one
 * error cell instead of crashing the whole table (blank page).
 */
const TableBodyCells = ({ visibleColumns, renderers }) => (
    <ErrorBoundary
        fallback={
            <td colSpan={visibleColumns.length} style={{ color: "#c0392b" }}>
                تعذّر عرض هذا الصف
            </td>
        }
    >
        {visibleColumns.map((col) => {
            const render = renderers[col.id];

            // AN EMPTY CELL, NEVER NOTHING. A visible column with no renderer
            // used to return null, so the header still drew its `<th>` while
            // the row drew one `<td>` fewer — and every cell after it shifted
            // left. The table then read as if the data were wrong: the actions
            // menu appeared under الحظر, the block button under التقييم.
            //
            // It is silent, it survives review, and it looks like a data bug
            // rather than a missing renderer. One placeholder `<td>` keeps the
            // row aligned and makes the gap visible where it actually is.
            return (
                <Fragment key={col.id}>
                    {render ? render() : <td className="text-muted">—</td>}
                </Fragment>
            );
        })}
    </ErrorBoundary>
);

export default TableBodyCells;
